import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Button, Modal } from 'react-bootstrap';
import { Card, Input, Row, Dropdown, Checkbox } from 'components';
import { AiFillCloseCircle } from 'react-icons/ai';
import Editor from 'jodit-react';
import ButtonBTN from 'react-bootstrap/Button';
import InputGroup from 'react-bootstrap/InputGroup';
import { IoClose } from 'react-icons/io5';
import { toast } from 'react-toastify';
import { Accordion, Form } from 'react-bootstrap';

const SendEmailModal = ({ _this }) => {
  const generateEmailPreviewForDynamicData = () => {
    let preview = _this.emailDataToSend.body;

    const rowsHTML = _this.selectedRows
      .map((item) => {
        const hsppData = _this.tableData.find((row) => row.location_id === item.location_id);
        const hspp_patients = hsppData?.active_hspp_patients || 0;
        const units_sold = hsppData?.total_units || 0;
        const patients_sold = hsppData?.unique_patients || 0;

        return `
      <tr>
          <td style="border: 1px solid #ddd; padding: 4px; font-size: 10px; text-align:center;;">${item.location_name}</td>
          <td style="border: 1px solid #ddd; padding: 4px; font-size: 10px; text-align:center;">${hspp_patients}</td>
          <td style="border: 1px solid #ddd; padding: 4px; font-size: 10px; text-align:center;">${units_sold}</td>
          <td style="border: 1px solid #ddd; padding: 4px; font-size: 10px; text-align:center;">${patients_sold}</td>
        </tr>
      `;
      })
      .join('');

    preview = preview.replace(
      '{{tableData}}',
      rowsHTML || `<tr><td colspan="4">No data selected.</td></tr>`
    );
    preview = preview.replace(/{{employee_name}}/g, '[Employee Name]');
    return preview;
  };
  const config = {
    height: 400, // Set your desired height in pixels
    readonly: false // all options from https://xdsoft.net/jodit/docs/
  };
  return (
    <Modal
      style={{ zIndex: 9999 }}
      // className="h-[90%]"
      show={_this.sendEmailModalVisibility}
      onHide={() => _this.setSendEmailModalVisibility(false)}
      fullscreen="lg-down"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      size="xl"
    >
      <Modal.Header>
        <Modal.Title id="contained-modal-title-vcenter">Send Red Zone Email</Modal.Title>
        <AiFillCloseCircle
          size={30}
          onClick={() => {
            // _this.setEmailDataToSend((prev) => ({ ...prev, new_email: '', email_ids: [] }));
            _this.setSendEmailModalVisibility(false);
          }}
        />
      </Modal.Header>
      <Modal.Body>
        <Card className="mb-3 flex mr-2">
          <div className="flex justify-between gap-2 items-start flex-wrap">
            {/* <div className="flex flex-row justify-between items-start flex-wrap"> */}
            <InputGroup className="w-[60%] flex justify-start items-center">
              <Input
                label="Email To:"
                className="w-[18rem] mb-3 text-sm"
                placeholder="email-id"
                type="text"
                required
                value={_this.addEmailData.employee_email}
                onChange={(e) => _this.setAddEmailData({ employee_email: e.target.value })}
              />
              <ButtonBTN
                className="h-10 text-sm"
                onClick={() => {
                  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

                  if (!emailRegex.test(_this.addEmailData.employee_email)) {
                    return toast.error('Invalid email address');
                  } else if (
                    _this.employeeDataToMail?.some(
                      (emp) => emp.employee_email === _this.addEmailData.employee_email
                    )
                  ) {
                    return toast.error('Email already exists');
                  } else {
                    const data = [..._this.employeeDataToMail];
                    const new_data = {
                      employee_email: _this.addEmailData.employee_email,
                      employee_name: _this.addEmailData.employee_email,
                      employee_locations: [..._this.selectedRows]
                    };

                    data.push(new_data);
                    _this.setEmployeeDataToMail(data);

                    _this.setAddEmailData({ employee_email: '' });
                  }
                }}
              >
                + Add Email
              </ButtonBTN>
            </InputGroup>

            <Button
              disabled={_this.employeeDataToMail?.length == 0}
              onClick={() => _this.handleEmailSubmit()}
            >
              Send Email
            </Button>
          </div>
          <div className="mb-3 w-full flex justify-start gap-2 flex-wrap">
            {_this.employeeDataToMail?.length > 0 &&
              _this.employeeDataToMail?.map((item, index) => (
                <div key={index}>
                  <div className="flex items-center gap-2 justify-between px-2 py-1 bg-gray-100 shadow-xs rounded-full border-2">
                    <span className="text-gray-500 font-medium">{item.employee_name}</span>
                    <button
                      onClick={() => {
                        const updated_ids = _this.employeeDataToMail.filter(
                          (emp) => emp.employee_email !== item.employee_email
                        );
                        _this.setEmployeeDataToMail(updated_ids);
                      }}
                      className=" rounded-full text-gray-500 hover:text-gray-600 cursor-pointer"
                      aria-label="Delete job"
                    >
                      <IoClose style={{ fontSize: '15px' }} />
                    </button>
                  </div>
                </div>
              ))}
          </div>

          <div>
            <Input
              label="Email Subject"
              className="mb-3 text-sm"
              placeholder="@subject"
              type="text"
              required
              value={_this.emailDataToSend?.subject}
              onChange={(e) =>
                _this.setEmailDataToSend({
                  ..._this.emailDataToSend,
                  subject: e.target.value
                })
              }
            />

            <h3 className="text-lg">
              Email Body <span className="text-red-600">*</span>
            </h3>
            <Editor
              config={config}
              value={generateEmailPreviewForDynamicData() || _this.emailDataToSend?.body}
              onBlur={(e) => _this?.setEmailDataToSend({ ..._this.emailDataToSend, body: e })}
              tabIndex={1}
            />
          </div>
        </Card>
      </Modal.Body>
      <Modal.Footer>
        <Button
          onClick={() => {
            _this.setEmailDataToSend((prev) => ({ ...prev, new_email: '', email_ids: [] }));
            _this.setSendEmailModalVisibility(false);
          }}
        >
          Cancel
        </Button>
        <Button onClick={() => _this.handleEmailSubmit()}>Submit</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default SendEmailModal;
